import React from 'react';
import {Link} from 'gatsby';

import ArticleCard from './category/ArticleCard';
import CategoryStyle from './CategoryStyle';
import tealChevronRight from '../../img/tealChevronRight.svg';

const Category = (props) => {
  const { categoryTitle, categoryUrl, articleList } = props;
  const articleListJsx = articleList.map((article, index) => {
    return <ArticleCard {...article} key={index} />;

  } )

  return (
    <CategoryStyle>
      <div className="categoryHeader">
        <div className="categoryTitle">{categoryTitle}</div>
        <Link 
          className="viewAllButton" 
          to={categoryUrl}
        >
          View All <img height="12px" layout="fixed" className="tealChevronRight" src={tealChevronRight} alt=""/>
        </Link>
      </div>
      <div className="articleList">
        {articleListJsx}
      </div>
    </CategoryStyle>
  );
}

export default Category;